import { handleTrack } from '../../utils/tracker';
import { RightArrow } from '../Icons/rightArrow/RightArrow';
import { FLIP_CARD } from '../income-tax/static/types';
import { setITRLocalStorage } from '../itr2/static/utils';

interface FLIP_CARD_PROPS {
  cardItem: FLIP_CARD;
  trackLabel: string;
  isVariant?: boolean;
}

export const FlipCard = ({
  cardItem,
  trackLabel,
}: FLIP_CARD_PROPS): JSX.Element => {
  const buttonLinkWithUtm = `${cardItem.buttonLink}_${trackLabel}_${cardItem.title}`;

  return (
    <div className="flip-card">
      <div
        className={`flip-card  group p-6 rounded-xl border border-grey-300 bg-white cursor-pointer sm:w-full flex flex-col justify-between h-full ${cardItem.className}`}
        onClick={(e) => {
          handleTrack({
            label: 'inpage_income_tax_efiling',
            obj: e.target,
          });
        }}
      >
        <div className="flip-card-inner flex flex-col justify-between">
          <div className="flip-card-front">
            <div className="flex gap-4 items-center">
              <div className={`rounded-xl`}>
                <img src={cardItem.icon} alt="" width={60} height={60} />
              </div>
              <div className="text-s-20 text-font-500 font-bold">
                {cardItem.title}
              </div>
            </div>
            <div className="text-base font-medium text-font-200 mt-4 min-h-[48px]">
              {cardItem.shortDesc}
            </div>

            <div className="text-font-500 text-s-14 font-bold mt-6 flex gap-2 items-center">
              Know more
              <RightArrow color="#314259" width={18} height={18} />
            </div>
          </div>

          <a
            className="flip-card-back flex-col justify-between"
            onClick={(e) => {
              setITRLocalStorage(buttonLinkWithUtm);
              handleTrack({
                label: `${trackLabel}_card_${cardItem.title}`,
                url: buttonLinkWithUtm,
                obj: e.target,
              });
            }}
            href={buttonLinkWithUtm}
          >
            <div className="text-font-500 text-base font-medium">
              {cardItem.fullDesc}
            </div>

            <div className="text-font-500 text-s-14 font-bold mt-6 flex gap-2 items-center">
              {cardItem.buttonText}
              <RightArrow color="#314259" width={18} height={18} />
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};
